import { render, staticRenderFns } from "./SortableTh.vue?vue&type=template&id=79ac13be&"
import script from "./SortableTh.vue?vue&type=script&lang=ts&"
export * from "./SortableTh.vue?vue&type=script&lang=ts&"
import style0 from "./SortableTh.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports